import React from "react";
import "./styles.scss";
import { PropsOrientation } from "utils";
import { ORIENTATIONS } from "../../constants";

const h1ForText = text => (
  <p className="item" key={text.trim()}>
    {text.trim()}
  </p>
);

const ClassName = props => {
  const orientation = PropsOrientation(props);
  let base = "paragraph-container ";
  if (orientation === ORIENTATIONS.LEFT) {
    base += ORIENTATIONS.LEFT;
  } else if (orientation === ORIENTATIONS.RIGHT) {
    base += ORIENTATIONS.RIGHT;
  } else if (orientation === ORIENTATIONS.CENTER) {
    base += ORIENTATIONS.CENTER;
  } else {
    base += ORIENTATIONS.LEFT;
  }
  return base;
};

export default props => {
  const { text = "" } = props;
  const lines = text.split("<br/>").map(item => h1ForText(item));
  return <div className={ClassName(props)}>{lines}</div>;
};
